/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-12-06 14:27:22
 * @Description:
 */
import {
  DownloadWithPopover,
  FTButton,
  FTDownloadSize,
  FTWatermark
} from "src/components";
import { EnumImageSizeType, MAX_WIDTH, imageProcesserSize } from "src/constant";
import { FTCanvasStore, FTImageStore, FTUserStore } from "src/store";
import { FTLang, hanldelFTUserProfile, utils } from "src/utils";
import { IconDownload, IconPlus } from "src/assets";
import React, { useEffect } from "react";
import {
  actionClickUp,
  actionImportImageClose,
  actionImportImageResult,
  actionImportImageShow
} from "src/analyze/actions";
import { useIsMobile, useLanguage } from "src/hooks";

import { autorun } from "mobx";
import { message } from "antd";

interface IProps {
  drawCanvasResize: () => void;
  download: (type: EnumImageSizeType) => void;
}
const FTCanvasPanel = (props: IProps) => {
  const [showDownload, setShowDownload] = React.useState(false);
  const [showWaterMark, setShowWaterMark] = React.useState(false);
  const [width, setWidth] = React.useState(0);
  const [height, setHeight] = React.useState(0);
  const [smallSize, setSmallSize] = React.useState({
    width: 0,
    height: 0
  });
  const [largerSize, setLargerSize] = React.useState({
    width: 0,
    height: 0
  });
  const isMobile = useIsMobile();
  useEffect(() => {
    autorun(() => {
      let { showDownload, isMobile } = FTCanvasStore;
      let { isVip } = FTUserStore;
      let { currentEffect, currentSize, acturalSize } = FTImageStore;
      let smallScale = utils.aspectFitScale(
        currentSize.width,
        currentSize.height,
        imageProcesserSize.IMAGE_SIDE_VALUE
      );
      let largerScale = utils.aspectFitScale(
        acturalSize.width,
        acturalSize.height,
        Number(imageProcesserSize.SUPPER_RESOLUTION_HIGH_ID)
      );
      setWidth(currentSize.width);
      setHeight(currentSize.height);
      setShowDownload(showDownload);
      setShowWaterMark(!isVip && currentEffect);
      setSmallSize({
        width: Math.round(currentSize.width * smallScale),
        height: Math.round(currentSize.height * smallScale)
      });
      setLargerSize({
        width: Math.round(acturalSize.width * largerScale),
        height: Math.round(acturalSize.height * largerScale)
      });
    });
  }, []);

  const changeImage = async () => {
    actionImportImageShow("change_image");
    let img = await utils.selectImageFile({ multiple: false ,useFocus:false});
    actionImportImageClose("change_image");
    if (img && img.length > 0) {
      actionImportImageResult("change_image", true);
      hanldelFTUserProfile();
      FTCanvasStore.changeLoading(true);
      const [firstImg] = img;
      const checkResult = await utils.checkImage(firstImg);
      if(!checkResult.result){
        message.error(t(checkResult.message));
        FTCanvasStore.changeLoading(false);
        return;
      }

      let {
        canvas: imageElement,
        acturalSize,
        currentSize
      } = await utils.getImageFromFile(img[0]);
      FTImageStore.uploadImageUrl = null;
      FTImageStore.setCurrentImageElement(
        imageElement,
        currentSize,
        acturalSize
      );
      FTImageStore.setCurrentImage(img[0]);
      props.drawCanvasResize();
      FTCanvasStore.changeLoading(false);
      FTImageStore.currentEffect = null;
      // change images 时 只上传图片，不应用特效
      //if (
      //  FTImageStore.currentEffect &&
      //  FTImageStore.currentEffect !== 'original'
      //) {
      //  actionClickUp(
      //    utils.toFixed(FTImageStore.currentEffect.id, 0),
      //    FTImageStore.currentEffect.name,
      //  );
      //  FTImageStore.getGoartEffect(FTImageStore.currentEffect);
      //}
    } else {
      actionImportImageResult("goart_change_image", false);
    }
  };
  const handleDownload = (type: EnumImageSizeType) => {
    props.download(type);
  };

  const {t} = useLanguage();

  return (
    <div
      className='canvas_panel'
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}>
      <FTButton className='canvas_panel_open' onClick={() => changeImage()}>
        <IconPlus />
        <span>{t("goart_change_image")}</span>
      </FTButton>
      {/* {isMobile && <FTWatermark theme='text' />} */}
      <div className='canvas_panel_right'>
        <DownloadWithPopover
          width={width}
          height={height}
          onDownloadHD={() => handleDownload(EnumImageSizeType.HD)}
          onDownloadPreview={() => handleDownload(EnumImageSizeType.Preview)}
        />
      </div>
    </div>
  );
};

export default FTCanvasPanel;
